// extracted by mini-css-extract-plugin
module.exports = {"win-card-box":"e9","winCardBox":"e9","win-card-btn-detail":"e-","winCardBtnDetail":"e-","win-card-dec":"e_","winCardDec":"e_","win-card-name":"fa","winCardName":"fa"};